<!-- 项目信息 -->
<template>
  <div>
    <k-form-build
      :value="jsonData"
      ref="KFB"
    />
  </div>
</template>
<script>
export default {
  name: 'ProjectSponsor',
  data() {
    return {
      jsonData: {
        'list': [
          {
            'type': 'input',
            'icon': 'icon-edit',
            'options': {
              'width': '100%',
              'minRows': 4,
              'maxRows': 6,
              'maxLength': null,
              'defaultValue': '',
              'clearable': false,
              'hidden': false,

              'placeholder': '项目编号'
            },
            'model': '8b91c08d-069e-1623-02d8-91b5a0895187',
            'key': '8b91c08d-069e-1623-02d8-91b5a0895187',
            'rules': [
              {
                'required': false,
                'message': '必填项'
              }
            ]
          }
        ],
        'config': {
          'layout': 'vertical',
          'labelCol': {
            'span': 4
          },
          'wrapperCol': {
            'span': 18
          },
          'hideRequiredMark': false,
          'customStyle': ''
        }
      }
    }
  },
  methods: {},
  mounted() {

  }
}
</script>
